import { httpCreate } from './http';

const http = httpCreate('/srv/banner');

export const banner = {
	//activityId
	getBannerById(id, params) {
		return http.get(`/${id}`, { params });
	},
	addBanner(data) {
		return http.post('', data);
	},
	updatePriority(data) {
		return http.post('/updatePriority', data);
	},

	updateBanner(id, data) {
		return http.put(`/${id}`, data);
	},
	//page, pageNum, pageSize ,type
	getBannerList(params) {
		return http.get('', { params });
	},
	//type, photoLive
	getByParam(data) {
		return http.post('/getByParam', data);
	},
	//activityId
	delBanner(id, params) {
		return http.delete(`/${id}`, { params });
	}
};
